import { ITransactionByBeneficiaryPurchaseMiles } from '@smiles/voebiz-core-corporate-club/dist/Types/GetListPurchaseMilesByBeneficiaryApi.types';
import { formatMiles } from 'helpers/format';
import { formatDate } from 'helpers/formatDate';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface RowProps {
  history: ITransactionByBeneficiaryPurchaseMiles;
}

function RowHistory({ history }: RowProps) {
  const { t } = useTranslation();

  return (
    <div className="corporate-club-extract__card__body__table__row">
      <div className="corporate-club-extract__card__body__table__row__data">
        <h4 className="corporate-club-extract__card__body__table__row__data__title">Nome da campanha</h4>
        <p className="corporate-club-extract__card__body__table__row__data__value">{history.campaignName}</p>
      </div>
      <div className="corporate-club-extract__card__body__table__row__data">
        <h4 className="corporate-club-extract__card__body__table__row__data__title">{t('common:date')}</h4>
        <p className="corporate-club-extract__card__body__table__row__data__value">{formatDate(history.created)}</p>
      </div>
      <div className="corporate-club-extract__card__body__table__row__data">
        <h4 className="corporate-club-extract__card__body__table__row__data__title">Milhas enviadas</h4>
        <p className="corporate-club-extract__card__body__table__row__data__value">
          {formatMiles(history.amount.toString())} {t('common:miles')}
        </p>
      </div>
    </div>
  );
}

export default RowHistory;
